import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "selected", "tooltip", "tooltipPlacement", "onClick", "use"];
import styled from 'foundations-theming/utils';
import { Button } from '../../Button';
import { Tooltip } from '../../Tooltip';
import { StyledContentWrapper } from '../../Typeahead/TypeaheadResultsItem';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ButtonChildWrapper = styled.span.withConfig({
  displayName: "DropdownMenuOption__ButtonChildWrapper",
  componentId: "sc-1c4w8wp-0"
})(() => {
  return {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexGrow: 1
  };
});
export const ButtonLabel = styled.span.withConfig({
  displayName: "DropdownMenuOption__ButtonLabel",
  componentId: "sc-1c4w8wp-1"
})(({
  theme
}) => {
  return {
    display: 'block',
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 'auto',
    marginInlineEnd: '0.25rem',
    minInlineSize: 0,
    textAlign: 'left',
    paddingBlock: theme.space['50'],
    marginBlock: `-${theme.space['50']}`,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    inlineSize: '100%',
    maxInlineSize: '100%',
    [`& ${StyledContentWrapper}`]: {
      '& > *:first-child': {
        marginBlockStart: theme.space['0'],
        alignItems: 'center'
      }
    },
    // Fix for external link icons being clipped in dropdown menus
    '& svg[data-icon-name="ExternalLink"]': {
      blockSize: '1em',
      inlineSize: '1em'
    }
  };
});
export const DropdownMenuOption = _ref => {
  let {
      children,
      selected = null,
      tooltip,
      tooltipPlacement = 'right',
      onClick,
      use = 'transparent'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const selectedProps = selected !== null ? {
    role: 'menuitemcheckbox',
    'aria-checked': selected
  } : {
    role: 'menuitem'
  };
  return /*#__PURE__*/_jsx(Tooltip, {
    title: tooltip,
    placement: tooltipPlacement,
    children: /*#__PURE__*/_jsx(Button, Object.assign({
      use: use
    }, rest, selectedProps, {
      onClick: onClick,
      children: /*#__PURE__*/_jsxs(ButtonChildWrapper, {
        children: [/*#__PURE__*/_jsx(ButtonLabel, {
          children: children
        }), selected && /*#__PURE__*/_jsx(SuccessIcon, {
          size: "200",
          color: "icon-core-subtle"
        })]
      })
    }))
  });
};